<!-- Loading Spinner -->
<div *ngIf="loading" class="page-loader"><div class="spinner"></div></div>
<div *ngIf="conversationReady">
  <div class="chat-container">
    <div class="chat-header">
      <img [src]="advisorProfile.avatar" class="advisor-avatar" [alt]="advisorProfile.name" />

      <div class="advisor-info">
        <div class="advisor-name">
          {{ advisorProfile.name }}
          <span class="status-dot" [ngClass]="{ 'online': advisorProfile.status}"></span>
        </div>
      </div>

      <div class="chat-header-actions">
        <a routerLink="/home" title="Home Page"><span class="material-symbols-outlined">home</span></a>
      </div>
    </div>

    <div #chatContainer class="chat-messages-wrapper">
      <div *ngIf="messagesLoading" class="chat-messages-loading"><div class="spinner"></div></div>
      <div *ngIf="!messagesLoading" class="chat-messages">
        <div class="chat-row" *ngFor="let message of messages" [ngClass]="{ 'customer': message.sendreType == eSenderType.Customer, 'advisor': message.sendreType == eSenderType.Adviser}">
          <div class="chat-bubble">
            <div *ngIf="message.attachments != null" class="message-attachments" [ngClass]="getAttachmentGridClass(message.attachments)">
              <div class="attachment-item" *ngFor="let attachment of message.attachments; let i = index">
                <div *ngIf="attachment.mediaType == enumMediaType.image" class="type-image"><img [src]="attachment.downloadUrl" (click)="openImage(message.attachments, i)" alt="{{attachment.fileName}}" /></div>
                <div *ngIf="attachment.mediaType == enumMediaType.video" class="type-video"><video [src]="attachment.downloadUrl" title="{{attachment.fileName}}" controls></video></div>
                <div *ngIf="attachment.mediaType == enumMediaType.audio" class="type-audio"><audio [src]="attachment.downloadUrl" title="{{attachment.fileName}}" controls></audio></div>
                <div *ngIf="attachment.mediaType == enumMediaType.voice" class="type-voice"><audio [src]="attachment.downloadUrl" title="{{attachment.fileName}}" controls></audio></div>
                <div *ngIf="attachment.mediaType == enumMediaType.document" class="type-document"><a [href]="attachment.downloadUrl" title="{{attachment.fileName}}" download><span class="material-symbols-outlined document-icon">insert_drive_file</span><span class="document-name">{{attachment.fileName}}</span></a></div>
              </div>
            </div>
            <div class="message-text">{{ message.text }}</div>
            <div class="message-meta">{{ message.time }}</div>
          </div>
        </div>
      </div>
    </div>

    <form class="chat-form" (ngSubmit)="sendMessage(isRecording)">
      <div class="input-wrapper">
        <div *ngIf="!isRecording" class="text-box">
          <button type="button" class="attachment-btn" (click)="toggleAttachmentPicker()" title="Attachments"><span class="material-symbols-outlined">attach_file</span></button>
          <input type="text" class="text-input" [(ngModel)]="newMessage" name="message" placeholder="Type your message..." required />
          <button type="button" class="emoji-btn" (click)="toggleEmojiPicker()" title="Add Emoji"><span class="material-symbols-outlined">sentiment_satisfied</span></button>
        </div>
        <div *ngIf="isRecording" class="record-box">
          <div *ngIf="isRecording" class="recording-status">
            <button class="delete-btn" type="button" (click)="cancelRecording()"><span class="material-symbols-outlined">delete</span></button>
            <span class="recording"><span class="material-symbols-outlined">radio_button_checked</span></span>
            <span class="timer">{{ recordingTime * 1000 | date:'mm:ss':'UTC' }}</span>
            <div class="waveform"><span *ngFor="let bar of [].constructor(10)"></span></div>
          </div>
        </div>
      </div>
      <button #recordBtn *ngIf="!newMessage && !isRecording" type="button" class="record-btn" (mousedown)="recordingMouseDown($event)" (touchstart)="recordingTouchStart($event)" (mouseup)="recordingMouseUpTouchEnd()" (touchend)="recordingMouseUpTouchEnd()" title="Hold to record">
        <span *ngIf="voiceRecordingSupported" class="material-symbols-outlined">mic</span>
        <span *ngIf="!voiceRecordingSupported" class="material-symbols-outlined">mic_off</span>
      </button>
      <button *ngIf="newMessage || isRecording" type="button" (click)="sendMessage(isRecording)" class="send-btn"><span class="material-symbols-outlined">send</span></button>
    </form>

    <div *ngIf="showEmojiPicker" (clickOutside)="showEmojiPicker = false" class="emoji-picker">
      <span (click)="addEmoji('😀')">😀</span>
      <span (click)="addEmoji('😂')">😂</span>
      <span (click)="addEmoji('👍')">👍</span>
      <span (click)="addEmoji('🎉')">🎉</span>
      <span (click)="addEmoji('❤️')">❤️</span>
    </div>

    <div *ngIf="showAttachmentPicker" (clickOutside)="showAttachmentPicker = false" class="attachment-picker">
      <!-- Buttons open popup -->
      <button mat-icon-button (click)="openAttachmentDialog(enumMediaType.image)"><span class="material-symbols-outlined">image_inset</span><h6>Photos</h6></button>
      <!--button mat-icon-button (click)="openAttachmentDialog('camera')"><span class="material-symbols-outlined">photo_camera</span><h6>Camera</h6></button-->
      <button mat-icon-button (click)="openAttachmentDialog(enumMediaType.video)"><span class="material-symbols-outlined">hangout_video</span><h6>Videos</h6></button>
      <button mat-icon-button (click)="openAttachmentDialog(enumMediaType.document)"><span class="material-symbols-outlined">docs</span><h6>Documents</h6></button>
    </div>
  </div>

  <div style="text-align: center; margin-bottom: 8px;" *ngIf="showUnSubscriptionBtn"><a href="#" (click)="unsubscribeFromPush($event)">Unsubscribe from Notifications</a></div>
  <div style="text-align: center;" *ngIf="isIosNotPWA">
    📱 Install this app to your Home Screen to enable push notifications.<br>
    <small>Open Safari → Share → Add to Home Screen</small>
  </div>
</div>
<div class="page-info" *ngIf="!conversationReady && isIosNotPWA">
  <div class="content">
    <div *ngIf="!isIosSafari" class="text-big">This app only works with <b>Safari</b>.<br>Please open the chat link in <b>Safari</b>.</div>
    <div *ngIf="isIosSafari"  class="text-main">
      In order to use all the web chat features, please install this app as instructed below:<br>
      <div>
        How to Install the App on iOS (Safari)
        <ol>
          <li><b>Open in Safari</b><br>Make sure you are viewing this app in the Safari browser on your iPhone or iPad.</li>
          <li><b>Tap the Share button</b><br>At the bottom of the screen, tap the Share icon (the square with an arrow pointing up).<br>👉 On iPad, the Share button is at the top right.</li>
          <li><b>Choose "Add to Home Screen"</b><br>In the menu that appears, scroll down and tap Add to Home Screen.</li>
          <li><b>Confirm installation</b><br>A preview screen will show the app name and icon. Tap Add (top-right corner).</li>
          <li><b>Use the app like a native app</b><br>You’ll now see the app on your home screen.<br>Open it from there anytime — it will run full screen like a regular app.</li>
        </ol>
      </div>
    </div>
  </div>
</div>
<!-- Subscribe Modal -->
<app-push-subscription-modal *ngIf="conversationReady && showSubscriptionModal" (subscribe)="acceptSubscribe()" (skip)="skipSubscribe()"></app-push-subscription-modal>

<!-- Error View -->
<app-error *ngIf="!conversationReady && conversationHasError" [errorViewModel]="errorViewModel"></app-error>